// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Containers/Boxes UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezContainer {
  padding: 0;
  background-color: transparent;
  border-color: transparent;
}

.ezContainer-width-100 {
  width: 100%;
}

.ez-debug-timezone-container {
  position: absolute;
  padding: 2px;
  left: 10px;
  top: 0;
  background-color: var(--ezClockerBabyBlue);
  color: var(--ezClockerGray);
  font-size: xx-small;
  font-style: italic;
}

.ezInstructionContainer {
  border-style: none;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
}

/* Input Containers/Boxes */
.ezContainer-date-picker {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  grid-row-gap: 4px;
  grid-column-gap: 4px;
  justify-content: stretch;
  align-content: top;
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: var(--ezClockerBlack);
  border-style: none;
}

.ezContainer-labeled-input-vertical {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  grid-row-gap: 4px;
  grid-column-gap: 0;
  justify-content: stretch;
  align-content: center;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: transparent;
  color: var(--ezClockerBlack);
  border-style: none;
}

.ezInputContainer {
  border-style: none;
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
}

.ezTransparentInputContainer {
  padding: 8px;
  background-color: transparent;
  color: var(--ezFontColor);
  border-style: none;
}

/* DEPRECATED: Switch to ezInputs-input-box */
.ezInputBox {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  justify-content: start;
  align-content: center;
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezContainers_InputBox {
  display: grid;
  padding: 4px;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  justify-content: start;
  align-content: center;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezContaner_CenterInputBox {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  justify-content: stretch;
  align-content: center;
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezCenterInputBox {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  justify-content: center;
  align-content: center;
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezLargeInputBox,
.ezContainers-large-input-box {
  display: grid;
  padding: 8px;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
}

.ezSmallInputBox,
.ezContainers-small-input-box {
  margin-top: 4px;
  margin-bottom: 4px;
}

.ezErrorContainer {
  margin: 4px;
  padding: 4px;
  min-height: 20px;
  min-width: 20px;
  background-color: var(--ezLightAlertRed);
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 4px 4px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 1px;
}

.ezErrorBox {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  min-height: 20px;
  min-width: 20px;
  background-color: var(--ezClockerErrorRed);
  background-image: url("/public/images/icons/error-red.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position-x: 4px;
  background-position-y: center;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

.ezContainer-validation-error-box {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  min-height: 17px;
  min-width: 17px;
  background-color: var(--ezClockerErrorRed);
  background-image: url("/public/images/icons/error-red.svg");
  background-size: 17px 17px;
  background-repeat: no-repeat;
  background-position-x: 4px;
  background-position-y: center;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

.ezWarningBox {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  min-height: 20px;
  min-width: 20px;
  background-color: var(--ezLightWarningYellow);
  background-image: url("/public/images/icons/warn-triangle-yellow.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: left;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderWarningYellow);
  border-radius: 3px;
}

.ezContainer-warning-no-image {
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 8px;
  min-height: 24px;
  background-color: var(--ezLightWarningYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezBorderWarningYellow);
  border-style: solid;
  border-radius: 3px;
  border-width: 1px;
}

.ezContainer-warning-no-image-thick-dark-alert-red-border {
  margin-bottom: 8px;
  padding: 8px;
  min-height: 24px;
  background-color: var(--ezLightWarningYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-radius: 3px;
  border-width: 3px;
}

.ez-floating-error-container {
  position: absolute;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  background-color: var(--ezClockerErrorRed);
  background-image: url("/public/images/icons/error-red.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: left;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderAlertRed);
}

.ezCenterContainer {
  margin: 0;
  padding: 4px;
  text-align: center;
}

/* ezClocker Boxes */
div.ezQuickStatusBox {
  position: fixed;
  display: none;
  z-index: 999;
  background-color: rgb(128 128 128/40%);
  font-size: 8pt;
  color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 2px;
  border-color: var(--ezBorderBabyBlue);
  box-shadow: 0 0 2px 2px rgb(0 0 0/40%);
  padding: 2px;
  margin: 4px;
}

.ezBabyBlueBox {
  padding: 4px;
  background-color: var(--ezClockerBabyBlue);
  color: var(--ezClockerBlack);
  font-family: var(--ezFontFamily);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  border-style: solid;
  border-color: var(--ezBorderBabyBlue);
  border-width: 1px;
  border-radius: 3px;
}

.ezContentsBox {
  display: inline-block;
}

.ezBlackBox {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerBlack);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezBlackBox8 {
  padding: 8px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerBlack);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSilverBox {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerSilver);
  border-color: #a7a9ab;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSilverBox8 {
  padding: 8px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerSilver);
  border-color: #a7a9ab;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerYellow-pad-4 {
  padding: 8px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderYellow);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ezClockerWhite containers
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Active
        ezContainer-ezClockerWhite-pad-4
        ezContainer-ezClockerWhite-pad-8
        ezContainer-ezClockerWhite-pad-10
        ezContainer-bottom-ezClockerWhite-pad-10
        ezContainer-ezClockerWhite-shadow
        ezContainer-default-ezClockerWhite
        ezContainers-ezClockerWhite-small-help
        (DEPRECATED) ezWhiteBox
        (DEPRECATED) ezWhiteBox8
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezContainer-ezClockerWhite-pad-4,
.ezWhiteBox {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerWhite-pad-4-no-border {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-style: none;
}

.ezContainer-ezClockerWhite-pad-8,
.ezWhiteBox8 {
  padding: 8px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerWhite-pad-10 {
  padding: 10px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-bottom-ezClockerWhite-pad-10 {
  padding: 10px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 0 0 3px 3px;
}

.ezContainer-default-ezClockerWhite {
  background-color: var(--ezClockerWhite);
  border-style: none;
}

.ezContainer-ezClockerWhite-shadow {
  background-color: var(--ezClockerWhite);
  border-style: none;
  box-shadow: 4px 4px 8px -2px var(--ezClockerGray);
}

.ezContainers-ezClockerWhite-small-content {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: var(--ezSmallFontSize);
}

.ezContainers-ezMobileBlue-pad2 {
  padding: 2px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerMobileBlue);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 2px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ezClockerSilver containers
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Active
        ezContainer-ezClockerSilver-pad-8
        ezContainer-ezClockerSilver-pad-10
        ezContainer-bottom-ezClockerSilver-pad-10
        ezContainer-ezClockerSilver-shadow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezContainer-ezClockerSilver-pad-4 {
  padding: 4px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerSilver-pad-8 {
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerSilver-pad-10 {
  padding: 10px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-bottom-ezClockerSilver-pad-10 {
  padding: 10px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 0 0 3px 3px;
}

.ezContainer-ezClockerSilver-shadow {
  background-color: var(--ezClockerSilver);
  border-style: none;
  box-shadow: 4px 4px 8px -2px var(--ezClockerGray);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ezClockerNavy containers
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Active
        ezContainer-navy4
        ezContainer-navy8
        ezContainer-top-navy4
        ezContainer-top-navy8
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezContainer-navy4 {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-navy8 {
  padding: 8px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-top-navy4 {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ezContainer-top-navy8 {
  padding: 8px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ezContainer-top-gray4 {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerGray);
  border-color: var(--ezBorderGray);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ez-white-borderless-box8 {
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border-style: none;
  border-radius: 3px;
}

.ezContainer-white-border-pad8-bottom-margin10 {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 10px;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-alpha-white-silver-border-8 {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  background-color: rgb(255 255 255/50%);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-white-right-aligned-button-container {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  background-color: rgb(255 255 255/50%);
  text-align: right;
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-transparent-button-bar-no-border {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  background-color: transparent;
}

.ezTransparentBox {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: transparent;
  border-color: transparent;
}

.ezTransparentBox8 {
  padding: 8px;
  color: var(--ezClockerBlack);
  background-color: transparent;
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayBox {
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  border-color: var(----ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayBox8 {
  padding: 8px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  border-color: var(----ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayMinBox {
  display: block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  border-color: var(----ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayMinBox8 {
  display: block;
  padding: 8px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezFontColor);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-basic-silver {
  background-color: var(--ezClockerSilver);
}

.ezContainer-navy-8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: var(--ezTitleFontWeight);
  font-size: var(--ezTitleFontSize);
  border-radius: 3px;
}

.ezContainer-title-navy-8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: var(--ezTitleFontWeight);
  font-size: var(--ezTitleFontSize);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ezPageContent {
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  overflow: auto;
}

.ezPageContentBlock {
  display: grid;
  padding: 4px;
  grid-row-gap: 2px;
  row-gap: 2px;
  grid-column-gap: 2px;
  column-gap: 2px;
  background-color: var(--ezWhite);
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezRightAlignedButtonContainer {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  text-align: right;
  background-color: transparent;
}

.ezCenterAlignedContainer {
  padding: 4px;
  text-align: center;
  background-color: transparent;
}

.ez-error-details-container {
  margin-top: 10px;
  background-color: var(--ezClockerWhite);
  padding: 2px;
  color: var(--ezClockerGray);
  font-size: small;
  font-style: italic;
}

.ezContaner-image-box {
  padding: 0;
  margin: 0;
  background-color: transparent;
}

.ezContainer-dialog-buttons {
  display: grid;
  justify-content: end;
  align-content: center;
  grid-template-rows: 100%;
  grid-template-columns: auto;
}

.ezContainer-dialog-buttons-x2 {
  display: grid;
  margin-top: 20px;
  justify-content: end;
  align-content: center;
  grid-template-rows: 100%;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
  column-gap: 8px;
}

/* Legal Disclaimer Boxes */
.ezContainer_below-button-legal-disclaimer {
  display: grid;
  justify-content: end;
  align-content: left;
  grid-template-rows: auto;
  grid-template-columns: auto;
}

.ezContainer_legal-disclaimer-small-screens {
  display: none;
}

/* Footer Boxes */
.ezContainer-link-footer {
  display: grid;
  margin-top: 20px;
  justify-content: center;
  align-content: center;
  grid-template-rows: 100%;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
}

.ezContainer-legal-links {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 4px;
  column-gap: 4px;
  grid-row-gap: 4px;
  row-gap: 4px;
  justify-content: stretch;
  align-content: center;
  padding: 4px;
  margin-top: 4px;
  background-color: var(--ezClockerWhite);
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezContainer-legal-link {
  display: grid;
  padding: 4px;
  align-content: stretch;
  text-align: center;
}

/* Margin Containers */
.ezContainer_TopMargin_8 {
  margin-top: 8px;
}

/* Border Containers */
.ezContainer-border-box {
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

.ezContainer-content-box {
  padding: 10px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
}

.ezContainer-scroll-box {
  padding: 8px;
  overflow: auto;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezClockerGray);
  box-shadow: inset 0 0 1px 1px rgb(109 110 112/50%);
}

.ezContainer-side-help-box {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  justify-content: start;
  align-content: start;
  margin-top: 0;
  padding: 4px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  overflow: auto;
}

.ezContainer-side-help-box-img {
  height: 32px;
  vertical-align: middle;
}

.ezContainer-side-help-box-title {
  color: var(--ezClockerNavy);
  font-size: 14pt;
  font-weight: bold;
  border-bottom-color: var(--ezClockerGray);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezContainer-side-help-box-content {
  padding: 4px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
}

.ezContainer-full-screen-overlay {
  display: grid;
  padding: 8px;
  grid-template-columns: auto;
  grid-template-rows: min-content auto;
  align-content: start;
  justify-content: stretch;
  background-color: transparent;
  overflow: hidden;
}

.ezContainer-integration-setup-header {
  padding: 8px;
  color: var(--ezFontColor);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 2px;
  margin-bottom: 20px;
}

.ezContainer-integration-logo {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: min-content min-content;
  justify-content: start;
  align-content: center;
  text-align: left;
  font-size: 14pt;
  font-weight: bold;
}

.ezContainer-integration-logo-img {
  vertical-align: middle;
  text-align: left;
  height: 28px;
}

.ezContainer-integration-logo-img-nosize {
  text-align: left;
  vertical-align: middle;
}

.ezContainer-integration-logo-text {
  text-align: left;
  font-size: 14pt;
  font-weight: bold;
}

.ezContainer-integration-input-container {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: auto;
  grid-template-rows: auto;
  align-content: start;
  justify-content: stretch;
  /*    border-color: var(--ezClockerNavy);
  border-width: 2px;*/
  border-style: none;
  overflow: auto;
}

.ezContainer-mini-help-box-img {
  height: 22px;
  vertical-align: middle;
}

.ezContainer-mini-help-box {
  padding: 4px;
  color: var(--ezClockerGray);
  font-size: 10pt;
  text-align: left;
}

.ezContainer-editor-info-box {
  margin-top: 4px;
  color: var(--ezClockerNavy);
  font-size: 10pt;
  text-align: left;
}

.ezContainer-input-info-box-white-text {
  margin-top: 4px;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  text-align: left;
}

.ezContiner-ezClockerNavy-pad8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

.ezContiner-ezClockerNavy-pad8-top-margin-10 {
  margin-top: 10px;
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

.ezContainer-display-contents {
  display: contents;
}

.ezContainer-glass-bubble-pad-8 {
  padding: 8px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-glass-bubble-pad-10 {
  padding: 10px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-glass-bubble-pad-20 {
  padding: 20px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-glass-bubble-pad-40 {
  padding: 40px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

/* Input Containers */
.ezContainer-radio-input-box {
  display: contents;
  padding: 0;
  margin: 0;
  background: transparent;
  border-width: 0;
  border-style: none;
}

.ezContainer-radio-check-input {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  align-content: middle;
  justify-content: start;
  grid-row-gap: 0;
  grid-column-gap: 8px;
}

.ezContainer-info-box-yellow {
  padding: 4px;
  background-color: var(--ezClockerInfoYellow);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
  border-style: solid;
}

.ezContainer-ezClockerYellow-pad8 {
  padding: 8px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
}

.ezContainer-contentBox-transparent {
  display: inline;
  background-color: transparent;
}

span.ezContainer-text {
  display: contents;
}

span.ezContainer-showids {
  display: contents;
  margin-left: 2px;
  margin-right: 2px;
  padding: 2px;
  font-size: 8pt;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Category Container Styles
| A transparent container with a 10px pad on the left
|-----------------------------------------------------------------
| Template
|   ezContainer_<name>-<backoungd-color>-<left-padding>
|
| Available Styles
|   ezContainer_tabbox-transparent-8px
|   ezContainer_tabbox-transparent-10px
|   ezContainer_tabbox-transparent-20px
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezContainer_tabbox-transparent-8px {
  padding-left: 10px;
}

.ezContainer_tabbox-transparent-10px {
  padding-left: 10px;
}

.ezContainer_tabbox-transparent-20px {
  padding-left: 20px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Category Container Styles
| A container with only a bottom border as an underline
|-----------------------------------------------------------------
| Template
|   ezContainer_<name>-<bottom-border-color>
|
| Available Styles
|   ezContainer_categorybox-navy
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezContainer_categorybox-navy {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0;
  padding-bottom: 4px;
  background-color: transparent;
  color: var(--ezClockerBlack);
  font-size: var(--ezFontSize);
  font-weight: bold;
  border-color: var(--ezClockerNavy);
  border-style: none;
  border-width: 0;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezContainer_CategoryContent {
  margin-left: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  color: var(--ezClockerBlack);
  font-size: var(--ezContentFontSize);
}

.ezContainer_EmployeeCard {
  padding: 4px;
  margin: 4px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-width: 2px;
  border-color: #032746;
}

.ezContainer-toolbutton {
  display: contents;
  padding-left: 4px;
  padding-right: 4px;
  background-color: transparent;
}

.ezContainer-archive-status {
  display: grid;
  padding: 2px;
  grid-template-columns: auto auto;
  grid-template-rows: 100%;
  color: var(--ezClockerNavy);
  font-size: 10pt;
  align-content: center;
  justify-content: end;
  border-style: none;
}

.ezContainer-unarchive-status {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 100%;
  padding: 2px;
  background-color: transparent;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  align-content: center;
  justify-content: end;
  border-style: none;
}

.ezContainer-title-box-ezClockerYellow-pad4 {
  padding: 4px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderYellow);
  border-style: solid;
  border-width: 1px;
  border-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.ezContainer-title-box-ezClockerNavy-pad-4 {
  padding: 4px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 0;
}

.ezContainer-title-box-ezClockerNavy-pad-8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 0;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 1023px) {
  .ezContainer-dialog-buttons-x2 {
    display: grid;
    margin-top: 20px;
    justify-content: stretch;
    align-content: center;
    grid-template-rows: 100%;
    grid-template-columns: auto auto;
    grid-column-gap: 8px;
    column-gap: 8px;
  }
}
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 768px) {
  /*
  .ezContainers_InputBox {
      display: grid;
      padding: 0;
      grid-template-columns: 100%;
      grid-template-rows: 50% 50%;
      justify-content: start;
      align-content: center;
      background-color: transparent;
      color: var(--ezFontColor);
  }

  .ezContaner_CenterInputBox {
      display: grid;
      padding: 0;
      grid-template-columns: 100%;
      grid-template-rows: auto auto;
      justify-content: stretch;
      align-content: center;
      background-color: transparent;
      color: var(--ezFontColor);
  }

  .ezContainer-dialog-buttons-x2 {
      display: grid;
      margin-top: 20px;
      justify-content: stretch;
      align-content: center;
      grid-template-rows: 100%;
      grid-template-columns: auto auto;
      grid-column-gap: 8px;
      column-gap: 8px;
  }

  .ezContainer_below-button-legal-disclaimer {
      display: none;
  }

  .ezContainer_legal-disclaimer-small-screens {
      display: grid;
      justify-content: left;
      align-content: left;
      grid-template-rows: auto;
      grid-template-columns: auto;
  }

  .ezContainer-link-footer {
      display: grid;
      margin-top: 20px;
      justify-content: center;
      align-content: center;
      grid-template-columns: 50%;
      grid-column-gap: 4px;
  }
  */
}
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  .ezContainers_InputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: 50% 50%;
    justify-content: start;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContaner_CenterInputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    justify-content: stretch;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContainer-dialog-buttons-x2 {
    display: grid;
    margin-top: 20px;
    justify-content: stretch;
    align-content: center;
    grid-template-rows: 100%;
    grid-template-columns: auto auto;
    grid-column-gap: 8px;
    column-gap: 8px;
  }
  .ezContainer_below-button-legal-disclaimer {
    display: none;
  }
  .ezContainer_legal-disclaimer-small-screens {
    display: grid;
    justify-content: left;
    align-content: left;
    grid-template-rows: auto;
    grid-template-columns: auto;
  }
  .ezContainer-legal-links {
    display: grid;
    grid-template-columns: auto;
    grid-column-gap: 2px;
    column-gap: 2px;
    grid-row-gap: 0;
    row-gap: 0;
    justify-content: center;
    align-content: center;
    padding: 0;
    margin-top: 2px;
    background-color: var(--ezClockerWhite);
    color: var(--ezContentFontColor);
    font-family: var(--ezFontFamily);
    font-size: var(--ezContentFontSize);
    font-weight: var(--ezContentFontWeight);
    font-style: var(--ezContentFontStyle);
    border-style: none;
  }
  .ezContainer-link-footer {
    display: grid;
    margin-top: 20px;
    justify-content: center;
    align-content: center;
    grid-template-columns: 50%;
    grid-column-gap: 4px;
  }
}
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezContainers_InputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: 50% 50%;
    justify-content: start;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContaner_CenterInputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    justify-content: stretch;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContainer-dialog-buttons-x2 {
    display: grid;
    margin-top: 8px;
    justify-content: stretch;
    align-content: center;
    grid-template-rows: 100%;
    grid-template-columns: auto auto;
    grid-column-gap: 2px;
    column-gap: 2px;
  }
  .ezContainer_below-button-legal-disclaimer {
    display: none;
  }
  .ezContainer_legal-disclaimer-small-screens {
    display: grid;
    justify-content: left;
    align-content: left;
    grid-template-rows: auto;
    grid-template-columns: auto;
  }
  .ezContainer-link-footer {
    display: grid;
    margin-top: 20px;
    justify-content: center;
    align-content: center;
    grid-template-columns: 50%;
    grid-column-gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-containers.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,UAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,0CAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;AAAJ;;AAGA,2BAAA;AACA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;;AAGA,6CAAA;AACA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAIA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;AADJ;;AAIA;;EAEI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;AADJ;;AAIA;;EAEI,eAAA;EACA,kBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,wCAAA;EACA,0BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,eAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;AADJ;;AAIA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;AADJ;;AAIA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,sEAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;AADJ;;AAKA;EACI,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,4BAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,4BAAA;EACA,eAAA;EACA,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EAEA,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;AAHJ;;AAMA;EACI,SAAA;EACA,YAAA;EACA,kBAAA;AAHJ;;AAMA,oBAAA;AACA;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,YAAA;EACA,WAAA;AAHJ;;AAMA;EACI,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,mBAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,qBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;;;;;;;;;;;;;;;CAAA;AAiBA;;EAGI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AALJ;;AAQA;EACI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,kBAAA;AALJ;;AASA;;EAGI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,uCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,4BAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAPJ;;AAUA;EACI,uCAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,uCAAA;EACA,kBAAA;EACA,iDAAA;AAPJ;;AAUA;EACI,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,iCAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,4CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;;AAUA;;;;;;;;;;CAAA;AAWA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,kBAAA;EACA,iDAAA;AAPJ;;AAUA;;;;;;;;;;CAAA;AAWA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAPJ;;AAUA;EACI,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,uCAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AAPJ;;AAWA;EACI,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;AARJ;;AAWA;EACI,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,cAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,cAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,wCAAA;AARJ;;AAWA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,qCAAA;EACA,iCAAA;EACA,kBAAA;AARJ;;AAWA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,qCAAA;EACA,iCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AARJ;;AAWA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AARJ;;AAWA;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;AARJ;;AAYA;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;AATJ;;AAYA;EACI,YAAA;EACA,kBAAA;EACA,6BAAA;AATJ;;AAYA;EACI,gBAAA;EACA,uCAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,UAAA;EACA,SAAA;EACA,6BAAA;AATJ;;AAYA;EACI,aAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;AATJ;;AAYA;EACI,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gCAAA;EACA,oBAAA;EACA,eAAA;AATJ;;AAYA,2BAAA;AACA;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;AATJ;;AAYA;EACI,aAAA;AATJ;;AAYA,iBAAA;AACA;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gCAAA;EACA,oBAAA;AATJ;;AAYA;EACI,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;EACA,kCAAA;EACA,kCAAA;AATJ;;AAYA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AATJ;;AAYA,sBAAA;AACA;EACI,eAAA;AATJ;;AAYA,sBAAA;AACA;EACI,kCAAA;EACA,mBAAA;EACA,iBAAA;AATJ;;AAYA;EACI,aAAA;EACA,uCAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AATJ;;AAaA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kDAAA;AAVJ;;AAaA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;AAVJ;;AAaA;EACI,YAAA;EACA,sBAAA;AAVJ;;AAaA;EACI,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,0BAAA;EACA,wBAAA;AAVJ;;AAaA;EACI,YAAA;EACA,4BAAA;EACA,eAAA;AAVJ;;AAaA;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,YAAA;EACA,yBAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,2BAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,sBAAA;EACA,gBAAA;EACA,YAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,sBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,wBAAA;EACA,oBAAA;EACA,wBAAA;EACA;qBAAA;EAEA,kBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,YAAA;EACA,sBAAA;AAVJ;;AAaA;EACI,YAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAcA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,iBAAA;AAXJ;;AAcA;EACI,YAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAeA,qBAAA;AACA;EACI,iBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAZJ;;AAeA;EACI,aAAA;EACA,gCAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;AAZJ;;AAeA;EACI,YAAA;EACA,4CAAA;EACA,4BAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;AAZJ;;AAeA;EACI,eAAA;EACA,6BAAA;AAZJ;;AAeA;EACI,iBAAA;AAZJ;;AAeA;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AAZJ;;AAgBA;;;;;;;;;;;mEAAA;AAYA;EACI,kBAAA;AAbJ;;AAgBA;EACI,kBAAA;AAbJ;;AAgBA;EACI,kBAAA;AAbJ;;AAiBA;;;;;;;;;mEAAA;AAUA;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,mCAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,WAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,YAAA;EACA,gCAAA;EACA,wBAAA;EACA,2BAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,gCAAA;EACA,wBAAA;EACA,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAdJ;;AAiBA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,gBAAA;IACA,wBAAA;IACA,qBAAA;IACA,wBAAA;IACA,gCAAA;IACA,oBAAA;IACA,eAAA;EAdN;AACF;AAkBA;;qEAAA;AAGA;EACI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAsCJ;AAoBA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EAlBN;EAqBE;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,6BAAA;IACA,wBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EAnBN;EAsBE;IACI,aAAA;IACA,gBAAA;IACA,wBAAA;IACA,qBAAA;IACA,wBAAA;IACA,gCAAA;IACA,oBAAA;IACA,eAAA;EApBN;EAuBE;IACI,aAAA;EArBN;EAwBE;IACI,aAAA;IACA,qBAAA;IACA,mBAAA;IACA,wBAAA;IACA,2BAAA;EAtBN;EAyBE;IACI,aAAA;IACA,2BAAA;IACA,oBAAA;IACA,eAAA;IACA,eAAA;IACA,UAAA;IACA,uBAAA;IACA,qBAAA;IACA,UAAA;IACA,eAAA;IACA,uCAAA;IACA,gCAAA;IACA,gCAAA;IACA,mCAAA;IACA,uCAAA;IACA,qCAAA;IACA,kBAAA;EAvBN;EA0BE;IACI,aAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,0BAAA;IACA,oBAAA;EAxBN;AACF;AA4BA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EA1BN;EA6BE;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,6BAAA;IACA,wBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EA3BN;EA8BE;IACI,aAAA;IACA,eAAA;IACA,wBAAA;IACA,qBAAA;IACA,wBAAA;IACA,gCAAA;IACA,oBAAA;IACA,eAAA;EA5BN;EA+BE;IACI,aAAA;EA7BN;EAgCE;IACI,aAAA;IACA,qBAAA;IACA,mBAAA;IACA,wBAAA;IACA,2BAAA;EA9BN;EAiCE;IACI,aAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,0BAAA;IACA,oBAAA;EA/BN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Containers/Boxes UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n.ezContainer {\r\n    padding: 0;\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n}\r\n\r\n.ezContainer-width-100 {\r\n    width: 100%;\r\n}\r\n\r\n.ez-debug-timezone-container {\r\n    position: absolute;\r\n    padding: 2px;\r\n    left: 10px;\r\n    top: 0;\r\n    background-color: var(--ezClockerBabyBlue);\r\n    color: var(--ezClockerGray);\r\n    font-size: xx-small;\r\n    font-style: italic;\r\n}\r\n\r\n.ezInstructionContainer {\r\n    border-style: none;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n}\r\n\r\n/* Input Containers/Boxes */\r\n.ezContainer-date-picker {\r\n    display: grid;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto auto;\r\n    grid-row-gap: 4px;\r\n    grid-column-gap: 4px;\r\n    justify-content: stretch;\r\n    align-content: top;\r\n    padding: 0;\r\n    margin: 0;\r\n    background-color: transparent;\r\n    color: var(--ezClockerBlack);\r\n    border-style: none;\r\n}\r\n\r\n.ezContainer-labeled-input-vertical {\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: auto auto;\r\n    grid-row-gap: 4px;\r\n    grid-column-gap: 0;\r\n    justify-content: stretch;\r\n    align-content: center;\r\n    margin-top: 8px;\r\n    margin-bottom: 8px;\r\n    background-color: transparent;\r\n    color: var(--ezClockerBlack);\r\n    border-style: none;\r\n}\r\n\r\n.ezInputContainer {\r\n    border-style: none;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n}\r\n\r\n.ezTransparentInputContainer {\r\n    padding: 8px;\r\n    background-color: transparent;\r\n    color: var(--ezFontColor);\r\n    border-style: none;\r\n}\r\n\r\n/* DEPRECATED: Switch to ezInputs-input-box */\r\n.ezInputBox {\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: auto auto;\r\n    justify-content: start;\r\n    align-content: center;\r\n    padding: 4px;\r\n    background-color: transparent;\r\n    color: var(--ezFontColor);\r\n}\r\n\r\n.ezContainers_InputBox {\r\n    display: grid;\r\n    padding: 4px;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: auto auto;\r\n    justify-content: start;\r\n    align-content: center;\r\n    background-color: transparent;\r\n    color: var(--ezFontColor);\r\n}\r\n\r\n.ezContaner_CenterInputBox {\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: auto auto;\r\n    justify-content: stretch;\r\n    align-content: center;\r\n    padding: 4px;\r\n    background-color: transparent;\r\n    color: var(--ezFontColor);\r\n}\r\n\r\n\r\n.ezCenterInputBox {\r\n    display: grid;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto auto;\r\n    justify-content: center;\r\n    align-content: center;\r\n    padding: 4px;\r\n    background-color: transparent;\r\n    color: var(--ezFontColor);\r\n}\r\n\r\n.ezLargeInputBox,\r\n.ezContainers-large-input-box {\r\n    display: grid;\r\n    padding: 8px;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto auto;\r\n}\r\n\r\n.ezSmallInputBox,\r\n.ezContainers-small-input-box {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.ezErrorContainer {\r\n    margin: 4px;\r\n    padding: 4px;\r\n    min-height: 20px;\r\n    min-width: 20px;\r\n    background-color: var(--ezLightAlertRed);\r\n    background-size: 20px 20px;\r\n    background-repeat: no-repeat;\r\n    background-position: 4px 4px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezErrorBox {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    padding-left: 28px;\r\n    min-height: 20px;\r\n    min-width: 20px;\r\n    background-color: var(--ezClockerErrorRed);\r\n    background-image: url(\"/public/images/icons/error-red.svg\");\r\n    background-size: 20px 20px;\r\n    background-repeat: no-repeat;\r\n    background-position-x: 4px;\r\n    background-position-y: center;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-validation-error-box {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    padding-left: 28px;\r\n    min-height: 17px;\r\n    min-width: 17px;\r\n    background-color: var(--ezClockerErrorRed);\r\n    background-image: url(\"/public/images/icons/error-red.svg\");\r\n    background-size: 17px 17px;\r\n    background-repeat: no-repeat;\r\n    background-position-x: 4px;\r\n    background-position-y: center;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezWarningBox {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    padding-left: 28px;\r\n    min-height: 20px;\r\n    min-width: 20px;\r\n    background-color: var(--ezLightWarningYellow);\r\n    background-image: url(\"/public/images/icons/warn-triangle-yellow.svg\");\r\n    background-size: 20px 20px;\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezBorderWarningYellow);\r\n    border-radius: 3px;\r\n\r\n}\r\n\r\n.ezContainer-warning-no-image {\r\n    margin-top: 8px;\r\n    margin-bottom: 8px;\r\n    padding: 8px;\r\n    min-height: 24px;\r\n    background-color: var(--ezLightWarningYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-color: var(--ezBorderWarningYellow);\r\n    border-style: solid;\r\n    border-radius: 3px;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezContainer-warning-no-image-thick-dark-alert-red-border {\r\n    margin-bottom: 8px;\r\n    padding: 8px;\r\n    min-height: 24px;\r\n    background-color: var(--ezLightWarningYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-style: solid;\r\n    border-radius: 3px;\r\n    border-width: 3px;\r\n}\r\n\r\n.ez-floating-error-container {\r\n    position: absolute;\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    padding-left: 28px;\r\n    background-color: var(--ezClockerErrorRed);\r\n\r\n    background-image: url(\"/public/images/icons/error-red.svg\");\r\n    background-size: 20px 20px;\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezBorderAlertRed);\r\n}\r\n\r\n.ezCenterContainer {\r\n    margin: 0;\r\n    padding: 4px;\r\n    text-align: center;\r\n}\r\n\r\n/* ezClocker Boxes */\r\ndiv.ezQuickStatusBox {\r\n    position: fixed;\r\n    display: none;\r\n    z-index: 999;\r\n    background-color: rgb(128 128 128 / 40%);\r\n    font-size: 8pt;\r\n    color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    border-color: var(--ezBorderBabyBlue);\r\n    box-shadow: 0 0 2px 2px rgb(0 0 0 / 40%);\r\n    padding: 2px;\r\n    margin: 4px;\r\n}\r\n\r\n.ezBabyBlueBox {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerBabyBlue);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    border-style: solid;\r\n    border-color: var(--ezBorderBabyBlue);\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContentsBox {\r\n    display: inline-block;\r\n}\r\n\r\n.ezBlackBox {\r\n    padding: 4px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezBlackBox8 {\r\n    padding: 8px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezSilverBox {\r\n    padding: 4px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerSilver);\r\n    border-color: #a7a9ab;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezSilverBox8 {\r\n    padding: 8px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerSilver);\r\n    border-color: #a7a9ab;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-ezClockerYellow-pad-4 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezBorderYellow);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    ezClockerWhite containers\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Active\r\n        ezContainer-ezClockerWhite-pad-4\r\n        ezContainer-ezClockerWhite-pad-8\r\n        ezContainer-ezClockerWhite-pad-10\r\n        ezContainer-bottom-ezClockerWhite-pad-10\r\n        ezContainer-ezClockerWhite-shadow\r\n        ezContainer-default-ezClockerWhite\r\n        ezContainers-ezClockerWhite-small-help\r\n        (DEPRECATED) ezWhiteBox\r\n        (DEPRECATED) ezWhiteBox8\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n\r\n.ezContainer-ezClockerWhite-pad-4,\r\n/* DEPRECATED: .ezWhiteBox */\r\n.ezWhiteBox {\r\n    padding: 4px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-ezClockerWhite-pad-4-no-border {\r\n    padding: 4px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerWhite);\r\n    border-style: none;\r\n}\r\n\r\n\r\n.ezContainer-ezClockerWhite-pad-8,\r\n/* DEPRECATED: .ezWhiteBox8 */\r\n.ezWhiteBox8 {\r\n    padding: 8px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-ezClockerWhite-pad-10 {\r\n    padding: 10px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-bottom-ezClockerWhite-pad-10 {\r\n    padding: 10px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 0 0 3px 3px;\r\n}\r\n\r\n.ezContainer-default-ezClockerWhite {\r\n    background-color: var(--ezClockerWhite);\r\n    border-style: none;\r\n}\r\n\r\n.ezContainer-ezClockerWhite-shadow {\r\n    background-color: var(--ezClockerWhite);\r\n    border-style: none;\r\n    box-shadow: 4px 4px 8px -2px var(--ezClockerGray);\r\n}\r\n\r\n.ezContainers-ezClockerWhite-small-content {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-size: var(--ezSmallFontSize);\r\n}\r\n\r\n.ezContainers-ezMobileBlue-pad2 {\r\n    padding: 2px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerMobileBlue);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    ezClockerSilver containers\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Active\r\n        ezContainer-ezClockerSilver-pad-8\r\n        ezContainer-ezClockerSilver-pad-10\r\n        ezContainer-bottom-ezClockerSilver-pad-10\r\n        ezContainer-ezClockerSilver-shadow\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezContainer-ezClockerSilver-pad-4 {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-ezClockerSilver-pad-8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-ezClockerSilver-pad-10 {\r\n    padding: 10px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-bottom-ezClockerSilver-pad-10 {\r\n    padding: 10px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 0 0 3px 3px;\r\n}\r\n\r\n.ezContainer-ezClockerSilver-shadow {\r\n    background-color: var(--ezClockerSilver);\r\n    border-style: none;\r\n    box-shadow: 4px 4px 8px -2px var(--ezClockerGray);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    ezClockerNavy containers\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Active\r\n        ezContainer-navy4\r\n        ezContainer-navy8\r\n        ezContainer-top-navy4\r\n        ezContainer-top-navy8\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezContainer-navy4 {\r\n    padding: 4px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerNavy);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-navy8 {\r\n    padding: 8px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerNavy);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-top-navy4 {\r\n    padding: 4px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerNavy);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.ezContainer-top-navy8 {\r\n    padding: 8px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerNavy);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.ezContainer-top-gray4 {\r\n    padding: 4px;\r\n    color: var(--ezClockerWhite);\r\n    background-color: var(--ezClockerGray);\r\n    border-color: var(--ezBorderGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.ez-white-borderless-box8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    border-style: none;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-white-border-pad8-bottom-margin10 {\r\n    margin-top: 0;\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n    margin-bottom: 10px;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-alpha-white-silver-border-8 {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    padding: 8px;\r\n    background-color: rgb(255 255 255 / 50%);\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-white-right-aligned-button-container {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    padding: 8px;\r\n    background-color: rgb(255 255 255 / 50%);\r\n    text-align: right;\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-transparent-button-bar-no-border {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    padding: 8px;\r\n    background-color: transparent;\r\n}\r\n\r\n\r\n.ezTransparentBox {\r\n    padding: 4px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n}\r\n\r\n.ezTransparentBox8 {\r\n    padding: 8px;\r\n    color: var(--ezClockerBlack);\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezLightGrayBox {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(----ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezLightGrayBox8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(----ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezLightGrayMinBox {\r\n    display: block;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(----ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezLightGrayMinBox8 {\r\n    display: block;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezFontColor);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-basic-silver {\r\n    background-color: var(--ezClockerSilver);\r\n}\r\n\r\n.ezContainer-navy-8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-weight: var(--ezTitleFontWeight);\r\n    font-size: var(--ezTitleFontSize);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-title-navy-8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-weight: var(--ezTitleFontWeight);\r\n    font-size: var(--ezTitleFontSize);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.ezPageContent {\r\n    margin-top: 4px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    padding: 0;\r\n    overflow: auto;\r\n}\r\n\r\n.ezPageContentBlock {\r\n    display: grid;\r\n    padding: 4px;\r\n    grid-row-gap: 2px;\r\n    row-gap: 2px;\r\n    grid-column-gap: 2px;\r\n    column-gap: 2px;\r\n    background-color: var(--ezWhite);\r\n    color: var(--ezFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n\r\n}\r\n\r\n.ezRightAlignedButtonContainer {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    padding: 8px;\r\n    text-align: right;\r\n    background-color: transparent;\r\n}\r\n\r\n.ezCenterAlignedContainer {\r\n    padding: 4px;\r\n    text-align: center;\r\n    background-color: transparent;\r\n}\r\n\r\n.ez-error-details-container {\r\n    margin-top: 10px;\r\n    background-color: var(--ezClockerWhite);\r\n    padding: 2px;\r\n    color: var(--ezClockerGray);\r\n    font-size: small;\r\n    font-style: italic;\r\n}\r\n\r\n.ezContaner-image-box {\r\n    padding: 0;\r\n    margin: 0;\r\n    background-color: transparent;\r\n}\r\n\r\n.ezContainer-dialog-buttons {\r\n    display: grid;\r\n    justify-content: end;\r\n    align-content: center;\r\n    grid-template-rows: 100%;\r\n    grid-template-columns: auto;\r\n}\r\n\r\n.ezContainer-dialog-buttons-x2 {\r\n    display: grid;\r\n    margin-top: 20px;\r\n    justify-content: end;\r\n    align-content: center;\r\n    grid-template-rows: 100%;\r\n    grid-template-columns: auto auto;\r\n    grid-column-gap: 8px;\r\n    column-gap: 8px;\r\n}\r\n\r\n/* Legal Disclaimer Boxes */\r\n.ezContainer_below-button-legal-disclaimer {\r\n    display: grid;\r\n    justify-content: end;\r\n    align-content: left;\r\n    grid-template-rows: auto;\r\n    grid-template-columns: auto;\r\n}\r\n\r\n.ezContainer_legal-disclaimer-small-screens {\r\n    display: none;\r\n}\r\n\r\n/* Footer Boxes */\r\n.ezContainer-link-footer {\r\n    display: grid;\r\n    margin-top: 20px;\r\n    justify-content: center;\r\n    align-content: center;\r\n    grid-template-rows: 100%;\r\n    grid-template-columns: auto auto;\r\n    grid-column-gap: 8px;\r\n}\r\n\r\n.ezContainer-legal-links {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto;\r\n    grid-column-gap: 4px;\r\n    column-gap: 4px;\r\n    grid-row-gap: 4px;\r\n    row-gap: 4px;\r\n    justify-content: stretch;\r\n    align-content: center;\r\n    padding: 4px;\r\n    margin-top: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezContentFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n    border-color: var(--ezBorderColorStone);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderWidth);\r\n}\r\n\r\n.ezContainer-legal-link {\r\n    display: grid;\r\n    padding: 4px;\r\n    align-content: stretch;\r\n    text-align: center;\r\n}\r\n\r\n/* Margin Containers */\r\n.ezContainer_TopMargin_8 {\r\n    margin-top: 8px;\r\n}\r\n\r\n/* Border Containers */\r\n.ezContainer-border-box {\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezContainer-content-box {\r\n    padding: 10px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezFontColor);\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 4px;\r\n\r\n}\r\n\r\n.ezContainer-scroll-box {\r\n    padding: 8px;\r\n    overflow: auto;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezClockerGray);\r\n    box-shadow: inset 0 0 1px 1px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezContainer-side-help-box {\r\n    display: grid;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto auto;\r\n    justify-content: start;\r\n    align-content: start;\r\n    margin-top: 0;\r\n    padding: 4px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    overflow: auto;\r\n}\r\n\r\n.ezContainer-side-help-box-img {\r\n    height: 32px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.ezContainer-side-help-box-title {\r\n    color: var(--ezClockerNavy);\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    border-bottom-color: var(--ezClockerGray);\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezContainer-side-help-box-content {\r\n    padding: 4px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n}\r\n\r\n.ezContainer-full-screen-overlay {\r\n    display: grid;\r\n    padding: 8px;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: min-content auto;\r\n    align-content: start;\r\n    justify-content: stretch;\r\n    background-color: transparent;\r\n    overflow: hidden;\r\n}\r\n\r\n.ezContainer-integration-setup-header {\r\n    padding: 8px;\r\n    color: var(--ezFontColor);\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.ezContainer-integration-logo {\r\n    display: grid;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: min-content min-content;\r\n    justify-content: start;\r\n    align-content: center;\r\n    text-align: left;\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n}\r\n\r\n.ezContainer-integration-logo-img {\r\n    vertical-align: middle;\r\n    text-align: left;\r\n    height: 28px;\r\n}\r\n\r\n.ezContainer-integration-logo-img-nosize {\r\n    text-align: left;\r\n    vertical-align: middle;\r\n}\r\n\r\n.ezContainer-integration-logo-text {\r\n    text-align: left;\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n}\r\n\r\n.ezContainer-integration-input-container {\r\n    display: grid;\r\n    width: 100%;\r\n    height: 100%;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto;\r\n    align-content: start;\r\n    justify-content: stretch;\r\n    /*    border-color: var(--ezClockerNavy);\r\n    border-width: 2px;*/\r\n    border-style: none;\r\n    overflow: auto;\r\n}\r\n\r\n.ezContainer-mini-help-box-img {\r\n    height: 22px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.ezContainer-mini-help-box {\r\n    padding: 4px;\r\n    color: var(--ezClockerGray);\r\n    font-size: 10pt;\r\n    text-align: left;\r\n}\r\n\r\n.ezContainer-editor-info-box {\r\n    margin-top: 4px;\r\n    color: var(--ezClockerNavy);\r\n    font-size: 10pt;\r\n    text-align: left;\r\n}\r\n\r\n.ezContainer-input-info-box-white-text {\r\n    margin-top: 4px;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    text-align: left;\r\n}\r\n\r\n\r\n.ezContiner-ezClockerNavy-pad8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContiner-ezClockerNavy-pad8-top-margin-10 {\r\n    margin-top: 10px;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-display-contents {\r\n    display: contents;\r\n}\r\n\r\n.ezContainer-glass-bubble-pad-8 {\r\n    padding: 8px;\r\n    background-color: var(--ezGlass-background);\r\n    box-shadow: var(--ezGlass-box-shadow);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezGlass-border);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-glass-bubble-pad-10 {\r\n    padding: 10px;\r\n    background-color: var(--ezGlass-background);\r\n    box-shadow: var(--ezGlass-box-shadow);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezGlass-border);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-glass-bubble-pad-20 {\r\n    padding: 20px;\r\n    background-color: var(--ezGlass-background);\r\n    box-shadow: var(--ezGlass-box-shadow);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezGlass-border);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-glass-bubble-pad-40 {\r\n    padding: 40px;\r\n    background-color: var(--ezGlass-background);\r\n    box-shadow: var(--ezGlass-box-shadow);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezGlass-border);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n\r\n/* Input Containers */\r\n.ezContainer-radio-input-box {\r\n    display: contents;\r\n    padding: 0;\r\n    margin: 0;\r\n    background: transparent;\r\n    border-width: 0;\r\n    border-style: none;\r\n}\r\n\r\n.ezContainer-radio-check-input {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    grid-template-rows: auto;\r\n    align-content: middle;\r\n    justify-content: start;\r\n    grid-row-gap: 0;\r\n    grid-column-gap: 8px;\r\n}\r\n\r\n.ezContainer-info-box-yellow {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerInfoYellow);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezBorderYellow);\r\n    border-radius: 3px;\r\n    border-style: solid;\r\n}\r\n\r\n.ezContainer-ezClockerYellow-pad8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezBorderYellow);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezContainer-contentBox-transparent {\r\n    display: inline;\r\n    background-color: transparent;\r\n}\r\n\r\nspan.ezContainer-text {\r\n    display: contents;\r\n}\r\n\r\nspan.ezContainer-showids {\r\n    display: contents;\r\n    margin-left: 2px;\r\n    margin-right: 2px;\r\n    padding: 2px;\r\n    font-size: 8pt;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Category Container Styles\r\n| A transparent container with a 10px pad on the left\r\n|-----------------------------------------------------------------\r\n| Template\r\n|   ezContainer_<name>-<backoungd-color>-<left-padding>\r\n|\r\n| Available Styles\r\n|   ezContainer_tabbox-transparent-8px\r\n|   ezContainer_tabbox-transparent-10px\r\n|   ezContainer_tabbox-transparent-20px\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n.ezContainer_tabbox-transparent-8px {\r\n    padding-left: 10px;\r\n}\r\n\r\n.ezContainer_tabbox-transparent-10px {\r\n    padding-left: 10px;\r\n}\r\n\r\n.ezContainer_tabbox-transparent-20px {\r\n    padding-left: 20px;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Category Container Styles\r\n| A container with only a bottom border as an underline\r\n|-----------------------------------------------------------------\r\n| Template\r\n|   ezContainer_<name>-<bottom-border-color>\r\n|\r\n| Available Styles\r\n|   ezContainer_categorybox-navy\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n.ezContainer_categorybox-navy {\r\n    margin-top: 20px;\r\n    margin-bottom: 10px;\r\n    padding: 0;\r\n    padding-bottom: 4px;\r\n    background-color: transparent;\r\n    color: var(--ezClockerBlack);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerNavy);\r\n    border-style: none;\r\n    border-width: 0;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezContainer_CategoryContent {\r\n    margin-left: 0;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    margin-right: 10px;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: var(--ezContentFontSize);\r\n}\r\n\r\n.ezContainer_EmployeeCard {\r\n    padding: 4px;\r\n    margin: 4px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    border-color: #032746;\r\n}\r\n\r\n.ezContainer-toolbutton {\r\n    display: contents;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    background-color: transparent;\r\n}\r\n\r\n.ezContainer-archive-status {\r\n    display: grid;\r\n    padding: 2px;\r\n    grid-template-columns: auto auto;\r\n    grid-template-rows: 100%;\r\n    color: var(--ezClockerNavy);\r\n    font-size: 10pt;\r\n    align-content: center;\r\n    justify-content: end;\r\n    border-style: none;\r\n}\r\n\r\n.ezContainer-unarchive-status {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    grid-template-rows: 100%;\r\n    padding: 2px;\r\n    background-color: transparent;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    align-content: center;\r\n    justify-content: end;\r\n    border-style: none;\r\n}\r\n\r\n.ezContainer-title-box-ezClockerYellow-pad4 {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezBorderYellow);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n}\r\n\r\n.ezContainer-title-box-ezClockerNavy-pad-4 {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-weight: bold;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 0;\r\n    border-top-right-radius: 3px;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.ezContainer-title-box-ezClockerNavy-pad-8 {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-weight: bold;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 0;\r\n    border-top-right-radius: 3px;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 1023px) {\r\n    .ezContainer-dialog-buttons-x2 {\r\n        display: grid;\r\n        margin-top: 20px;\r\n        justify-content: stretch;\r\n        align-content: center;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: auto auto;\r\n        grid-column-gap: 8px;\r\n        column-gap: 8px;\r\n    }\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 768px) {\r\n    /*\r\n    .ezContainers_InputBox {\r\n        display: grid;\r\n        padding: 0;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 50% 50%;\r\n        justify-content: start;\r\n        align-content: center;\r\n        background-color: transparent;\r\n        color: var(--ezFontColor);\r\n    }\r\n\r\n    .ezContaner_CenterInputBox {\r\n        display: grid;\r\n        padding: 0;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: auto auto;\r\n        justify-content: stretch;\r\n        align-content: center;\r\n        background-color: transparent;\r\n        color: var(--ezFontColor);\r\n    }\r\n\r\n    .ezContainer-dialog-buttons-x2 {\r\n        display: grid;\r\n        margin-top: 20px;\r\n        justify-content: stretch;\r\n        align-content: center;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: auto auto;\r\n        grid-column-gap: 8px;\r\n        column-gap: 8px;\r\n    }\r\n\r\n    .ezContainer_below-button-legal-disclaimer {\r\n        display: none;\r\n    }\r\n\r\n    .ezContainer_legal-disclaimer-small-screens {\r\n        display: grid;\r\n        justify-content: left;\r\n        align-content: left;\r\n        grid-template-rows: auto;\r\n        grid-template-columns: auto;\r\n    }\r\n\r\n    .ezContainer-link-footer {\r\n        display: grid;\r\n        margin-top: 20px;\r\n        justify-content: center;\r\n        align-content: center;\r\n        grid-template-columns: 50%;\r\n        grid-column-gap: 4px;\r\n    }\r\n    */\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 480px) {\r\n    .ezContainers_InputBox {\r\n        display: grid;\r\n        padding: 0;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 50% 50%;\r\n        justify-content: start;\r\n        align-content: center;\r\n        background-color: transparent;\r\n        color: var(--ezFontColor);\r\n    }\r\n\r\n    .ezContaner_CenterInputBox {\r\n        display: grid;\r\n        padding: 0;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: auto auto;\r\n        justify-content: stretch;\r\n        align-content: center;\r\n        background-color: transparent;\r\n        color: var(--ezFontColor);\r\n    }\r\n\r\n    .ezContainer-dialog-buttons-x2 {\r\n        display: grid;\r\n        margin-top: 20px;\r\n        justify-content: stretch;\r\n        align-content: center;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: auto auto;\r\n        grid-column-gap: 8px;\r\n        column-gap: 8px;\r\n    }\r\n\r\n    .ezContainer_below-button-legal-disclaimer {\r\n        display: none;\r\n    }\r\n\r\n    .ezContainer_legal-disclaimer-small-screens {\r\n        display: grid;\r\n        justify-content: left;\r\n        align-content: left;\r\n        grid-template-rows: auto;\r\n        grid-template-columns: auto;\r\n    }\r\n\r\n    .ezContainer-legal-links {\r\n        display: grid;\r\n        grid-template-columns: auto;\r\n        grid-column-gap: 2px;\r\n        column-gap: 2px;\r\n        grid-row-gap: 0;\r\n        row-gap: 0;\r\n        justify-content: center;\r\n        align-content: center;\r\n        padding: 0;\r\n        margin-top: 2px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezContentFontColor);\r\n        font-family: var(--ezFontFamily);\r\n        font-size: var(--ezContentFontSize);\r\n        font-weight: var(--ezContentFontWeight);\r\n        font-style: var(--ezContentFontStyle);\r\n        border-style: none;\r\n    }\r\n\r\n    .ezContainer-link-footer {\r\n        display: grid;\r\n        margin-top: 20px;\r\n        justify-content: center;\r\n        align-content: center;\r\n        grid-template-columns: 50%;\r\n        grid-column-gap: 4px;\r\n    }\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 319px) {\r\n    .ezContainers_InputBox {\r\n        display: grid;\r\n        padding: 0;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 50% 50%;\r\n        justify-content: start;\r\n        align-content: center;\r\n        background-color: transparent;\r\n        color: var(--ezFontColor);\r\n    }\r\n\r\n    .ezContaner_CenterInputBox {\r\n        display: grid;\r\n        padding: 0;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: auto auto;\r\n        justify-content: stretch;\r\n        align-content: center;\r\n        background-color: transparent;\r\n        color: var(--ezFontColor);\r\n    }\r\n\r\n    .ezContainer-dialog-buttons-x2 {\r\n        display: grid;\r\n        margin-top: 8px;\r\n        justify-content: stretch;\r\n        align-content: center;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: auto auto;\r\n        grid-column-gap: 2px;\r\n        column-gap: 2px;\r\n    }\r\n\r\n    .ezContainer_below-button-legal-disclaimer {\r\n        display: none;\r\n    }\r\n\r\n    .ezContainer_legal-disclaimer-small-screens {\r\n        display: grid;\r\n        justify-content: left;\r\n        align-content: left;\r\n        grid-template-rows: auto;\r\n        grid-template-columns: auto;\r\n    }\r\n\r\n    .ezContainer-link-footer {\r\n        display: grid;\r\n        margin-top: 20px;\r\n        justify-content: center;\r\n        align-content: center;\r\n        grid-template-columns: 50%;\r\n        grid-column-gap: 4px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
